import React from "react";
import Header from "./Header";

// Inner pages historically rendered a separate template header here. That
// header has drifted from the customized home-page navigation and causes the
// dropdown lists to fall into the page layout. Keep this compatibility
// component so existing page imports continue to work, while rendering the
// same responsive header on every route.
const HeaderTwo = () => <Header />;

export default HeaderTwo;
